import ChatPageSvg from "../svg/ChatPageSvg";
import CoursesPageSvg from "../svg/CoursesPageSvg";
import HomePageSvg from "../svg/HomePageSvg";
import NavigationSvg from "../svg/NavigationSvg";
import SearchPageSvg from "../svg/SearchPageSvg";

export const tabsPagesConst = {
  tabs: [
    {
      link: "/",
      img: HomePageSvg,
      text: "Home",
    },
    {
      link: "/courses",
      img: CoursesPageSvg,
      text: "Courses",
    },
    {
      link: "/search",
      img: SearchPageSvg,
      text: "Search",
    },
    {
      link: "/chat",
      img: ChatPageSvg,
      text: "Chat",
    },
  ],
  navigation: {
    link: "/navigation",
    img: NavigationSvg,
  },
};
